// measurement-slider.js - Desktop + Mobile
document.addEventListener('DOMContentLoaded', function () {
  // Initialize after a short delay to ensure DOM is fully loaded
  setTimeout(initMeasurementSliders, 500);

  let isInitializing = false;

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        const measurementSliders = document.querySelectorAll(
          'integer-range:not([data-slider-initialized]) div.price-slider.desktop',
        );
        if (measurementSliders.length > 0 && !isInitializing) {
          isInitializing = true;
          setTimeout(() => {
            initMeasurementSliders();
            isInitializing = false;
          }, 300);
        }
      }
    }
  });

  // Start observing the document or a specific parent element
  observer.observe(document.body, { childList: true, subtree: true });
});

function initMeasurementSliders() {
  // Find all integer-range containers that don't have sliders yet (both desktop and mobile)
  const measurementRanges = document.querySelectorAll(
    'integer-range:not([data-slider-initialized])',
  );


  measurementRanges.forEach(function (container, index) {
    const isMobile = container.closest('.mobile-facets__details') !== null;
    const context = isMobile ? 'Mobile' : 'Desktop';

    const minInput = container.querySelector('input.integer-from');
    const maxInput = container.querySelector('.integer-to');

    if (!minInput || !maxInput) {
      console.log(
        ` Missing inputs in ${context} measurement range ${index + 1}`,
      );
      return;
    }

    // Find slider container
    const sliderContainer = container.querySelector('div.price-slider');
    if (!sliderContainer) {
      return;
    }

    // Get range bounds from checkboxes (desktop checkboxes only, since mobile uses integer-range)
    let checkboxes = [];
    const filterParam = container.getAttribute('data-filter-param');

    if (container.checkboxes && container.checkboxes.length > 0) {
      checkboxes = container.checkboxes;
   
    } else {
      // Fallback: find desktop checkboxes manually (exclude mobile)
      checkboxes = Array.from(
        document.querySelectorAll(`input[name="${filterParam}"]`),
      ).filter(
        (cb) =>
          !cb.closest('.mobile-facets__details') &&
          !cb.closest('.no-js-list, .no-js'),
      );
    }

    if (checkboxes.length === 0) {
      console.log(` No checkboxes found for ${context} range ${index + 1}`);
      return;
    }

    // Auto-detect min/max from sorted checkboxes
    const minValue = parseInt(checkboxes[0].value);
    const maxValue = parseInt(checkboxes[checkboxes.length - 1].value);

    // Get current values from inputs
    const currentMin = minInput.value ? parseInt(minInput.value) : minValue;
    const currentMax = maxInput.value ? parseInt(maxInput.value) : maxValue;


    // Skip if already has noUiSlider
    if (sliderContainer.noUiSlider) {
      console.log(
        ` Slider already exists for ${context} range ${index + 1}, skipping`,
      );
      return;
    }

    try {
      // Initialize noUiSlider
      noUiSlider.create(sliderContainer, {
        start: [currentMin, currentMax],
        connect: true,
        step: 1,
        range: {
          min: minValue,
          max: maxValue,
        },
      });

      sliderContainer.noUiSlider.on('update', function (values) {
        const [minVal, maxVal] = values.map((v) => parseInt(v));
        
        // Update input values immediately during drag
        minInput.value = minVal;
        maxInput.value = maxVal;
      });
      
      // CRITICAL: Process changes when slider interaction is complete
      sliderContainer.noUiSlider.on('change', function (values) {
        const [minVal, maxVal] = values.map((v) => parseInt(v));
        
        // Update input values (redundant but safe)
        minInput.value = minVal;
        maxInput.value = maxVal;

        // Find filter pill
        const pillElements = document.querySelectorAll(`[data-pill-text="${filterParam}"]`); 

        Array.from(pillElements).forEach((pillElement) => {         
          // Update the active pill (filter summary) with the latest values
          if (pillElement && minVal && maxVal) {
            let originalString = pillElement.innerText;
            pillElement.textContent = originalString.replace(/(\d+)\s*cm\s*-\s*(\d+)\s*cm/, `${minVal} cm - ${maxVal} cm`);
          }
        })
        
        // TRIGGER INTEGERRANGE PROCESSING
        triggerIntegerRangeProcessing(container, context);
      });

      // Update slider when inputs change directly
      minInput.addEventListener('change', function () {
        const value = parseInt(this.value);
        if (!isNaN(value)) {
          sliderContainer.noUiSlider.set([value, null]);
        }
      });

      maxInput.addEventListener('change', function () {
        const value = parseInt(this.value);
        if (!isNaN(value)) {
          sliderContainer.noUiSlider.set([null, value]);
        }
      });

      // Mark as initialized
      container.setAttribute('data-slider-initialized', 'true');
     
    } catch (error) {
      console.error(
        ` Error creating ${context} slider for range ${index + 1}:`,
        error,
      );
    }
  });
}

function triggerIntegerRangeProcessing(container, context = 'Unknown') {
  try {
    // Desktop (manual): the slider updates the inputs but does NOT auto-apply — the whole
    // popover commits together via "Bruk"/Enter. Just flag the pending change. Mobile keeps
    // the original auto-submit-on-release behaviour.
    if (container.manualMode) {
      if (typeof container.markDirty === 'function') container.markDirty();
      return;
    }

    if (
      container.clearTimerAndProcess &&
      typeof container.clearTimerAndProcess === 'function'
    ) {

      container.clearTimerAndProcess();
      return;
    }

    if (
      container.processFilter &&
      typeof container.processFilter === 'function'
    ) {
    
      container.processFilter();
      return;
    }


    const fromInput = container.querySelector('.integer-from');
    const toInput = container.querySelector('.integer-to');

    if (fromInput && toInput) {
      fromInput.dispatchEvent(new Event('blur', { bubbles: true }));
      toInput.dispatchEvent(new Event('blur', { bubbles: true }));

    }
  } catch (error) {
    console.error(` ${context} - Processing error:`, error);
  }
}
